import { motion } from 'motion/react';

import { useTranslation } from '../i18n/hooks';

const targetIcons = [
  '/images/icons/target-audience-icon-1.svg',
  '/images/icons/target-audience-icon-2.svg',
  '/images/icons/target-audience-icon-3.svg',
];

export default function TargetAudienceSection() {
  const t = useTranslation();

  return (
    <motion.section
      id="target-audience"
      className="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-10 bg-white py-12 sm:py-16 md:py-20"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      {/* Title Section */}
      <motion.div
        className="flex w-full flex-col items-center gap-1"
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        <motion.h2
          className="w-full max-w-[654px] text-center text-[32px] leading-normal font-bold text-black"
          style={{ fontFamily: 'Almarai, sans-serif' }}
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
        >
          {t.targetAudience.title}
        </motion.h2>
      </motion.div>

      {/* Cards Container */}
      <div className="w-full px-4 sm:px-8 lg:px-[120px]">
        <div className="flex w-full flex-col items-stretch justify-stretch gap-6 md:flex-row">
          {t.targetAudience.items.map((item, index) => (
            <motion.div
              key={index}
              className="flex flex-1 flex-col items-center gap-6 rounded-[18px] border border-[#E5E5E5] bg-white p-6 md:flex-row md:gap-4"
              initial={{
                y: 100,
                opacity: 0,
                scale: 0.9,
              }}
              whileInView={{
                y: 0,
                opacity: 1,
                scale: 1,
              }}
              transition={{
                delay: 0.2 + index * 0.2,
                duration: 0.8,
                ease: 'easeOut',
              }}
              viewport={{ once: true }}
              whileHover={{
                y: -10,
                scale: 1.02,
                borderColor: '#22c55e',
                boxShadow: '0 15px 30px rgba(34, 197, 94, 0.1)',
              }}
            >
              {/* Icon Container */}
              <motion.div
                className="flex h-[42px] w-[42px] items-center justify-center rounded-[8px] bg-[#E8FBEE]"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img
                  src={targetIcons[index]}
                  alt={`Target audience ${index + 1}`}
                  // width={24}
                  // height={24}
                  className="h-8 w-8"
                />
              </motion.div>

              {/* Text Container */}
              <motion.div
                className="flex flex-1 flex-col items-end gap-6"
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.6 + index * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
              >
                <p
                  className="w-full text-[18px] leading-[1.2] text-black"
                  style={{ fontFamily: 'Almarai, sans-serif' }}
                >
                  {item}
                </p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
